import {
  NewGameListParams,
  NewGamePageInfo,
} from '@/common-pages/casino/casino.service';
import {http} from '@/utils';

export type Provider = {
  id: number;
  name: string;
  logo: string;
};

export type GameCategory = {
  id: number;
  name: string;
  logo: string;
};

export function getGameCategory(name: 'casino' | 'liveCasino') {
  return http.post<any, GameCategory[]>('app/homeGames/getGameCategory', {
    name,
  });
}

// 获取厂商列表
export function getGameProvider(name: 'casino' | 'liveCasino') {
  return http.post<any, Provider[]>('app/homeGames/getGameProvider', {name});
}
export function postNewGameList(params: NewGameListParams) {
  return http.post<NewGameListParams, NewGamePageInfo>(
    'app/homeGames/getList',
    params,
  );
}
